import React from "react";
import Loader from 'react-loader-spinner';
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { numberWithCommas } from "../../service/utilService";

export default function LineChartComp(props) {
  const {data,leftYAxisLabel,rightYAxisLabel,xDataKey,firstLineDataKey,secondLineDataKey,loader} = props;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload) {
        const payload0 = payload[1] || {};
        const payload1 = payload[0] || {};
        return (
            <div className="line-chart_custom-tooltip">
                <p>{payload0.payload?.month}</p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload0.stroke }}></span> {rightYAxisLabel==='Accepted Transactions' ? "Accepted" : "Transcation"} : {payload0.value} {rightYAxisLabel==='Accepted Transactions'&& <>(&#8377;{numberWithCommas(payload0.payload?.accepted_amt || 0, 2)})</>} </p>
                <p className="label"><span className="color-dot" style={{ backgroundColor: payload1.stroke }}></span> {rightYAxisLabel==='Accepted Transactions' ? "Rejected" : "Violation"} : {payload1.value} </p>
            </div>
        );
    }
    return null;
  }; 

  function formatYAxis(value) {
    if(rightYAxisLabel==='Accepted Transactions')
    return numDifferentiation(value);
    else return value;
  }

  const numDifferentiation = (value) => {
    var val = Math.abs(value)
    if (val >= 10000000) {
        val = (val / 10000000).toFixed(2) + ' Cr';
    } else if (val >= 100000) {
        val = (val / 100000).toFixed(2) + ' Lac';
    } else if (val >= 1000) {
      val = (val / 1000).toFixed(2) + 'K';
    } 
    return val;
}
  

  return (
    loader  
      ? <Loader className="loader chart-loader"
       type="ThreeDots"
        color="#9c1d26"
        width={100}
        visible={loader}
        />
    : (data.length>0  ?
    <ResponsiveContainer height={250} width="100%">
      <LineChart data={data} margin={{right: 10,  left: 10, top: 35}}>
        <CartesianGrid vertical={false} stroke="#cdcdcd" strokeDasharray="2" />
        <XAxis dataKey={xDataKey} />
        <YAxis yAxisId="left" tickLine={false} axisLine={false} width={70} label={{ value: leftYAxisLabel,  angle: -90, position: "insideLeft", dy: (rightYAxisLabel==='Accepted Transactions'? 60 : 30) ,dx:-10, stroke: "#B2ACAC",}} />
        <YAxis yAxisId="right" tickLine={false} axisLine={false} tickFormatter={formatYAxis} width={95} 
        orientation="right"tickMargin={8}label={{ value: rightYAxisLabel, angle: -90,position: "insideRight",  dy :(rightYAxisLabel==='Accepted Transactions'? -55 : -40), stroke: "#B2ACAC",}} />
        <Tooltip content={<CustomTooltip />} />
        <Line yAxisId="left" dataKey={firstLineDataKey} stroke="#FDA629" activeDot={{ r: 5 }} strokeWidth={3} />
        <Line yAxisId="right" dataKey={secondLineDataKey} stroke="#DB3236" activeDot={{ r: 5 }} strokeWidth={3} />
      </LineChart>
    </ResponsiveContainer>
    : <p className="no-record-found">Record Not Found</p> )
  );
}
